exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table {\n  margin-top: 2px !important;\n  width: 100%;\n  margin: 0 auto;\n  clear: both;\n  padding: 30px 0; }\n\n:host {\n  display: table;\n  border-collapse: separate;\n  border-spacing: 0 2px;\n  clear: both;\n  table-layout: fixed;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table/table.component.scss
// module id = ../../../../../src/app/shared/components/table/table.component.scss
// module chunks = 12